import { render, staticRenderFns } from "./cardSetUp.vue?vue&type=template&id=6a55e09e&"
import script from "./cardSetUp.vue?vue&type=script&lang=js&"
export * from "./cardSetUp.vue?vue&type=script&lang=js&"
import style0 from "./cardSetUp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cardSetUp.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports